var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcademic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 162 162",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_219_1147)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.0498,
    cy: 76.9502,
    r: 76.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9413 33.6843H56.5698C53.1765 33.6843 50.4258 36.4351 50.4258 39.8283V42.4088C50.4258 45.802 53.1765 48.5528 56.5698 48.5528H83.9413C87.3345 48.5528 90.0853 45.802 90.0853 42.4088V39.8283C90.0853 36.4351 87.3345 33.6843 83.9413 33.6843Z",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8998 66.0017H61.2192C57.826 66.0017 55.0752 68.7525 55.0752 72.1457V74.7262C55.0752 78.1194 57.826 80.8702 61.2192 80.8702H74.8998C78.2931 80.8702 81.0438 78.1194 81.0438 74.7262V72.1457C81.0438 68.7525 78.2931 66.0017 74.8998 66.0017Z",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.005 89.5075H40.8154C39.241 89.5034 37.7322 88.8766 36.6184 87.7638C35.5047 86.651 34.8765 85.1427 34.8711 83.5683V79.3852C34.8751 77.81 35.5027 76.3003 36.6166 75.1864C37.7305 74.0726 39.2401 73.445 40.8154 73.4409H50.4257",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.084 65.167H99.4038C96.0105 65.167 93.2598 67.9178 93.2598 71.311V73.8915C93.2598 77.2847 96.0105 80.0355 99.4038 80.0355H113.084C116.478 80.0355 119.228 77.2847 119.228 73.8915V71.311C119.228 67.9178 116.478 65.167 113.084 65.167Z",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4404 41.1184H103.766C104.42 41.1211 105.047 41.3827 105.509 41.846C105.972 42.3093 106.232 42.9368 106.233 43.5914V60.5283",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2339 119.116C75.6055 119.116 79.1494 115.573 79.1494 111.201C79.1494 106.829 75.6055 103.285 71.2339 103.285C66.8623 103.285 63.3184 106.829 63.3184 111.201C63.3184 115.573 66.8623 119.116 71.2339 119.116Z",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.244 119.116C110.615 119.116 114.159 115.573 114.159 111.201C114.159 106.829 110.615 103.285 106.244 103.285C101.872 103.285 98.3281 106.829 98.3281 111.201C98.3281 115.573 101.872 119.116 106.244 119.116Z",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2334 89.5076V97.8685",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.244 81.7456V97.7405",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9385 48.5527V60.5079",
    stroke: "#177D84",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_219_1147",
    x: 0.549805,
    y: 0.450195,
    width: 161,
    height: 161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_219_1147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_219_1147",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademic);
export default __webpack_public_path__ + "static/media/academic.210ea38f3e29ab5ab63c04c3e69cfa6e.svg";
export { ForwardRef as ReactComponent };